import * as React from 'react';

import { DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import { CommonStyles } from '../../common/react/CommonStyles';
import { AngularContext } from '../../ts/factories/AngularContextFactory';
import { DeviceSizes } from '../../devicePreview/services/DevicePreviewService';
import {
  ModalInstance,
  ReactModalOptions,
  ReactModalService
} from '../../ts/services/ReactModalService';
import { DevicePreviewModal, DevicePreviewModalProps } from '../components/DevicePreviewModal';

// TODO:
// Once the lightbox styles are flushed out, we should abstract it out into either its own class or
// as a lightbox option inside ReactModalService.
export namespace DevicePreviewModalBuilder {
  // Specific to Device Preview.  Usually, widgets will not require this sizing, but the viz viewer requires a position:absolute parent.
  const maxDeviceHeight: number = Object.keys(DeviceSizes).
    map(key => parseInt(DeviceSizes[key].height, 10)).
    reduce((maxValue, currentValue) => Math.max(maxValue, currentValue));
  const headerAndDeviceControlsHeight: number = 65;
  const bottomPadding: number = 18;
  const dialogHeight: number = maxDeviceHeight + headerAndDeviceControlsHeight + bottomPadding;

  function getDialogContent(angularContext: AngularContext, vizPath: string, dismiss: () => void): JSX.Element {
    const devicePreviewModalProps: DevicePreviewModalProps = {
      angularContext: angularContext,
      vizPath: vizPath,
      dismiss: dismiss,
    };
    return React.createElement(DevicePreviewModal, devicePreviewModalProps);
  }

  function getDialogStyle(): React.CSSProperties {
    return {
      backgroundColor: CommonStyles.Colors.Grey40,
      fontSize: 14,
      color: CommonStyles.Colors.White,
      border: 'none',
    };
  }

  function getDialogBodyStyle(): React.CSSProperties {
    return {
      position: 'relative',
      height: dialogHeight,
      paddingTop: 18
    };
  }

  function getDevicePreviewModalOptions(angularContext: AngularContext, vizPath: string, dismiss: () => void): ReactModalOptions{
    return {
      type: DialogType.Uber,
      dialogBodyStyle: getDialogBodyStyle(),
      dialogContent: getDialogContent(angularContext, vizPath, dismiss),
      dialogStyle: getDialogStyle(),
      showCloseButton: true,
      positioningBehavior: DialogPositioningBehavior.Maximized,
      shouldReturnFocusOnClose: true
    };
  }

  export function openPreview(angularContext: AngularContext, vizPath: string) {
    let modalInstance: ModalInstance;

    const dismiss = () => {
      modalInstance && modalInstance.dismiss();
    };

    const modalOptions: ReactModalOptions = getDevicePreviewModalOptions(angularContext, vizPath, dismiss);

    modalInstance = ReactModalService.open(modalOptions);
  }
}
